// impressions loaded on view
// mystery maybe used for load?

const mappings = [
    {
        widgetIds: [3083],
        trackings: {
            widgetLoaded: [
                `<script src="https://cdn.doubleverify.com/dvtp_src.js?ctx=11301032&cmp=23249973&sid=5606875&plc=256422141&adsrv=1&btreg=&btadsrv=&crt=&tagtype=&dvtagver=6.1.src" type="text/javascript"></script>`
            ],
            quizImpression: [
                `<script language='JavaScript1.1' src="https://ad.doubleclick.net/ddm/trackimpj/N1033118.3546877SPEAKABLE/B23249973.256422141;dc_trk_aid=452648758;dc_trk_cid=122257120;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"></script>`
            ]
        }
    },
    {
        widgetIds: [3075],
        trackings: {
            widgetLoaded: [
                `<script src="https://cdn.doubleverify.com/dvtp_src.js?ctx=11301032&cmp=23249973&sid=5606875&plc=256272574&adsrv=1&btreg=&btadsrv=&crt=&tagtype=&dvtagver=6.1.src" type="text/javascript"></script>`
            ],
            sentimentPollImpression: [
                `<script language='JavaScript1.1' src="https://ad.doubleclick.net/ddm/trackimpj/N1033118.3546877SPEAKABLE/B23249973.256272574;dc_trk_aid=452584046;dc_trk_cid=122195376;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"></script>`
            ]
        }
    },
    {
        widgetIds: [3106],
        trackings: {
            donationInitiation: [
                `<img src="https://pubads.g.doubleclick.net/activity;dc_iu=/49944529/DFPAudiencePixel;ord=timestamp;dc_seg=860742866?" width=1 height=1 border=0/>`
            ],
            donationCompletion: [
                `<img src="https://pubads.g.doubleclick.net/activity;dc_iu=/49944529/DFPAudiencePixel;ord=timestamp;dc_seg=862280532?" width=1 height=1 border=0/>`
            ]
        }
    },
    {
        widgetIds: [3311],
        trackings: {
            widgetLoaded: [
                `<script src="https://cdn.doubleverify.com/dvtp_src.js?ctx=11301032&cmp=23542041&sid=5606875&plc=261211441&adsrv=1&btreg=&btadsrv=&crt=&tagtype=&dvtagver=6.1.src" type="text/javascript"></script>`,
                `<script language='JavaScript1.1' src="https://ad.doubleclick.net/ddm/trackimpj/N1033118.3546877SPEAKABLE/B23542041.261211441;dc_trk_aid=456921296;dc_trk_cid=125225809;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"></script>`
            ]
        }
    },
    {
        widgetIds: [3371],
        trackings: {
            widgetLoadedMobile: [
                `<div><script language='JavaScript1.1' src="https://ad.doubleclick.net/ddm/trackimpj/N1026613.3546877SPEAKABLE/B23523362.261070980;dc_trk_aid=457898334;dc_trk_cid=125651946;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"></script><script type="application/javascript" src="https://pixel.adsafeprotected.com/rjss/st/370228/41275502/skeleton.js"></script><noscript><img src="https://pixel.adsafeprotected.com/rfw/st/370228/41275501/skeleton.gif" border=0 width=1 height=1 alt=""></noscript></div>`
            ],
            widgetLoadedDesktop: [
                `<div><script language='JavaScript1.1' src="https://ad.doubleclick.net/ddm/trackimpj/N1026613.3546877SPEAKABLE/B23523362.261071523;dc_trk_aid=457898334;dc_trk_cid=125651946;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"></script><script TYPE="application/javascript" src="https://pixel.adsafeprotected.com/rjss/st/370228/41275504/skeleton.js"></script><noscript><img src="https://pixel.adsafeprotected.com/rfw/st/370228/41275503/skeleton.gif" border=0 width=1 height=1 alt=""></noscript></div>`
            ],
            onClick: [
                `https://ad.doubleclick.net/ddm/trackclk/N1026613.3546877SPEAKABLE/B23523362.261861104;dc_trk_aid=457898334;dc_trk_cid=125651946;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=`
            ]
        }
    },
    {
        widgetIds: [3278],
        trackings: {
            widgetLoadedMobile: [
                `<div><script language='JavaScript1.1' src="https://ad.doubleclick.net/ddm/trackimpj/N1026613.3546877SPEAKABLE/B23523362.260668736;dc_trk_aid=457898334;dc_trk_cid=125651946;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"></script><script type="application/javascript" src="https://pixel.adsafeprotected.com/rjss/st/370228/41275500/skeleton.js"></script><noscript><img src="https://pixel.adsafeprotected.com/rfw/st/370228/41275499/skeleton.gif" border=0 width=1 height=1 alt=""></noscript></div>`
            ],
            widgetLoadedDesktop: [
                `<div><script language='JavaScript1.1' src="https://ad.doubleclick.net/ddm/trackimpj/N1026613.3546877SPEAKABLE/B23523362.261071703;dc_trk_aid=457898334;dc_trk_cid=125651946;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"></script><script type="application/javascript" src="https://pixel.adsafeprotected.com/rjss/st/370228/41275506/skeleton.js"></script><noscript><img src="https://pixel.adsafeprotected.com/rfw/st/370228/41275505/skeleton.gif" border=0 width=1 height=1 alt=""></noscript></div>`
            ],
            onClick: [
                `https://ad.doubleclick.net/ddm/trackclk/N1026613.3546877SPEAKABLE/B23523362.262267770;dc_trk_aid=457898334;dc_trk_cid=125651946;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=`
            ]
        }
    },
    {
        widgetIds: [3219, 3208, 3221, 3209],
        trackings: {
            widgetLoaded: [
                `<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=29335251&PluID=0&ord=timestamp&rtu=-1" width="1" height="1" />`
            ],
            donationInitiation: [
                `<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=29336057&PluID=0&ord=timestamp&rtu=-1" width="1" height="1" />`
            ],
            donationCompletion: [
                `<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=29336059&PluID=0&ord=timestamp&rtu=-1" width="1" height="1" />`
            ]
        }
    },
    {
        widgetIds: [3302, 3280],
        trackings: {
            widgetImpression: [
                `<script async src="https://www.googletagmanager.com/gtag/js?id=AW-803471589"></script>`,
                `<script>
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'AW-803471589');
                </script>`,
                `<script>
                    !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
                    },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='//static.ads-twitter.com/uwt.js',
                    a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
                    // Insert Twitter Pixel ID and Standard Event data below
                    twq('init','o1vo5');
                    twq('track','PageView');
                </script>`
            ]
        }
    },
    {
        widgetIds: [3424],
        trackings: {
            widgetLoaded: [
                `<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=29410304&PluID=0&ord=timestamp&rtu=-1" width="1" height="1" />`
            ],
            donationCompletion: [
                `<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=29410305&PluID=0&ord=timestamp&rtu=-1" width="1" height="1" />`
            ],
            donationInitiation: [
                `<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=29410306&PluID=0&ord=timestamp&rtu=-1" width="1" height="1" />`
            ]
        }
    },
    {
        //Note: Set Facebook Pixels id to 1609223442625207 in back office for all Everytown articles
        widgetIds: [2756, 2891, 2758, 3532],
        useThirdPartyFBTracking: true,
        useEverytownTracking: true,
        trackings: {
            widgetLoaded: [
                (externalSiteId, externalPlacementId) => `<script src="https://ad.atdmt.com/i/t.js;adv=11302203236902;ec=11302239331934;c.a=Action-Button;s.a=${externalSiteId};p.a=${externalPlacementId};a.a=1;" async></script>`
            ],
            engaged: [
                (externalSiteId, externalPlacementId) => `<img src="https://ad.atdmt.com/c/img;adv=11302203236902;ec=11302239331934;c.a=Action-Button;s.a=${externalSiteId};p.a=${externalPlacementId};a.a=1;qpb=1;" width="1" height="1" />`
            ],
            emailCompletion: [
                () => window.fbq('track', 'CompleteRegistration')
            ],
            petitionCompletion: [
                () => window.fbq('track', 'CompleteRegistration')
            ],
        }
    },
    {
        widgetIds: [3784], //CondeNast_Vogue_ConvPixel Pixel ID: 194548100955309
        useThirdPartyFBTracking: true,
        dontAutoInitFBPixel: true,
        trackings: {
            widgetImpression: [
                () => window.fbq('init', '194548100955309'),
                () => window.fbq('track', 'PageView')
            ],
            donationCompletion: [
                () => window.fbq('track', 'Purchase', {value: '0.00', currency: 'USD'})
            ]
        }
    },
    {
        widgetIds: [2758],
        trackings: {
            emailInitiation: [
                '<img src="https://r.bidswitch.net/pixel?id=581&response_type=img">'
            ],
            emailCompletion: [
                '<img src="https://r.bidswitch.net/pixel?id=572&response_type=img">'
            ]
        }
    },
    {
        widgetIds: [3615],
        trackings: {
            widgetLoaded: [`<script language='JavaScript1.1' src="https://ad.doubleclick.net/ddm/trackimpj/N9515.3546877SPEAKABLE/B24169709.273695367;dc_trk_aid=468032458;dc_trk_cid=132390912;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"></script>`],
            emailInitiation: [
                '<img src="https://r.bidswitch.net/pixel?id=580&response_type=img">'
            ],
            emailCompletion: [
                '<img src="https://r.bidswitch.net/pixel?id=575&response_type=img">'
            ]
        }
    },
    {
        widgetIds: [3614],
        trackings: {
            widgetLoaded: [`<script language='JavaScript1.1' src="https://ad.doubleclick.net/ddm/trackimpj/N9515.3546877SPEAKABLE/B24169709.273695367;dc_trk_aid=468032458;dc_trk_cid=132390912;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"></script>`],
            emailInitiation: [
                '<img src="https://r.bidswitch.net/pixel?id=579&response_type=img">'
            ],
            emailCompletion: [
                '<img src="https://r.bidswitch.net/pixel?id=574&response_type=img">'
            ]
        }
    },
    {
        widgetIds: [4223],
        trackings: {
            widgetLoaded: [`<script language='JavaScript1.1' src="https://ad.doubleclick.net/ddm/trackimpj/N9515.3546877SPEAKABLE/B24169709.273695367;dc_trk_aid=468032458;dc_trk_cid=132390912;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"></script>`],
            emailInitiation: [
                '<img src="https://r.bidswitch.net/pixel?id=582&response_type=img">'
            ],
            emailCompletion: [
                '<img src="https://r.bidswitch.net/pixel?id=583&response_type=img">'
            ]
        }
    },
    {
        widgetIds: [3550, 3549], //Calcasa
        trackings: {
            initiated: [
                `<!-- Global site tag (gtag.js) - Google Ads: 689621571 -->
                <script async src="https://www.googletagmanager.com/gtag/js?id=AW-689621571"></script>
                <script>
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'AW-689621571');

                    gtag('event', 'conversion', {
                        send_to: 'AW-689621571/wA0MCOHJzMsBEMOU68gC',
                        value: 1.0,
                        currency: 'USD',
                        aw_remarketing_only: true
                    });
                </script>`
            ]
        }
    },
    {
        widgetIds: [3650],//Tommy - dial
        trackings: {
            widgetImpression: [
                `<script language='JavaScript1.1' src="https://ad.doubleclick.net/ddm/trackimpj/N1033118.3546877SPEAKABLE/B23929713.269889667;dc_trk_aid=464662869;dc_trk_cid=130249451;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"></script>`,
                `<script type="text/javascript" src="https://z.moatads.com/crossmediadcm87381835184/moatad.js#moatClientLevel2=5606875&moatClientLevel1=23929713&moatClientLevel3=269889667&zMoatADV=9171495&moatClientLevel4=130249451&zMoatSSTG=1"></script>`,
                `<img src="https://beacon.krxd.net/ad_impression.gif?confid=tqlszga8y&campaignid=%ebuy!&advertiserid=%eadv!&placementid=%epid!&adid=%eaid!&creativeid=%ecid!&siteid=%esid!" width="1" height="1" />`
            ]

        }
    },
    {
        widgetIds: [3651],//Tommy - sentiment
        trackings: {
            widgetImpression: [
                `<script language='JavaScript1.1' src="https://ad.doubleclick.net/ddm/trackimpj/N1033118.3546877SPEAKABLE/B23929713.269967186;dc_trk_aid=464705735;dc_trk_cid=130249451;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?"></script>`,
                `<script type="text/javascript" src="https://z.moatads.com/crossmediadcm87381835184/moatad.js#moatClientLevel2=5606875&moatClientLevel1=23929713&moatClientLevel3=269967186&zMoatADV=9171495&moatClientLevel4=130249451&zMoatSSTG=1"></script>`,
                `<img src="https://beacon.krxd.net/ad_impression.gif?confid=tqlszga8y&campaignid=%ebuy!&advertiserid=%eadv!&placementid=%epid!&adid=%eaid!&creativeid=%ecid!&siteid=%esid!" width="1" height="1" />`
            ]
        }
    },
    {
        widgetIds: [3776],
        trackings: {
            widgetLoaded: [
                `<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=29705295&PluID=0&ord=timestamp&rtu=-1" width="1" height="1" />`
            ],
            donationInitiation: [
                `<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=29708947&PluID=0&ord=timestamp&rtu=-1" width="1" height="1" />`
            ],
            donationCompletion: [
                `<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=29708948&PluID=0&ord=timestamp&rtu=-1" width="1" height="1" />`
            ]
        }
    },
    {
        widgetIds: [3775],
        trackings: {
            widgetLoaded: [
                `<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=29705296&PluID=0&ord=timestamp&rtu=-1" width="1" height="1" />`
            ],
            donationInitiation: [
                `<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=29708949&PluID=0&ord=timestamp&rtu=-1" width="1" height="1" />`
            ],
            donationCompletion: [
                `<img src="https://bs.serving-sys.com/serving/adServer.bs?cn=display&c=19&mc=imp&pli=29708950&PluID=0&ord=timestamp&rtu=-1" width="1" height="1" />`
            ]
        }
    },
];

export default mappings;

// SAMPLE TRACKING
// =============================
// {
//     widgetIds: [2731],
//     trackings: {
//         sentimentPollImpression: [
//             `<a href="https://ad.doubleclick.net/ddm/jump/N7140.3546877SPEAKABLE/B22226397.245241124;sz=1x1;ord=timestamp?">
//                 <img src="https://ad.doubleclick.net/ddm/ad/N7140.3546877SPEAKABLE/B22226397.245241124;sz=1x1;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?" border=0 width=1 height=1 alt="Advertisement">
//             </a>`,
//             `<script src="https://cdn.doubleverify.com/dvtp_src.js?ctx=11646196&cmp=22226397&sid=5332969&plc=245241124&adsrv=1&btreg=&btadsrv=&crt=&tagtype=&dvtagver=6.1.src" type="text/javascript"></script>`
//         ],
//         quizImpression: [
//             `<a href="https://ad.doubleclick.net/ddm/jump/N7140.3546877SPEAKABLE/B22226397.245241124;sz=1x1;ord=timestamp?">
//                 <img src="https://ad.doubleclick.net/ddm/ad/N7140.3546877SPEAKABLE/B22226397.245241124;sz=1x1;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?" border=0 width=1 height=1 alt="Advertisement">
//             </a>`,
//             `<script src="https://cdn.doubleverify.com/dvtp_src.js?ctx=11646196&cmp=22226397&sid=5332969&plc=245241124&adsrv=1&btreg=&btadsrv=&crt=&tagtype=&dvtagver=6.1.src" type="text/javascript"></script>`
//         ],
//         sentimentPollCompletion: [
//             `<a href="https://ad.doubleclick.net/ddm/jump/N7140.3546877SPEAKABLE/B22226397.245241127;sz=1x1;ord=timestamp?">
//                 <img src="https://ad.doubleclick.net/ddm/ad/N7140.3546877SPEAKABLE/B22226397.245241127;sz=1x1;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?" border=0 width=1 height=1 alt="Advertisement">
//             </a>`,
//             `<script src="https://cdn.doubleverify.com/dvtp_src.js?ctx=11646196&cmp=22226397&sid=5332969&plc=245241127&adsrv=1&btreg=&btadsrv=&crt=&tagtype=&dvtagver=6.1.src" type="text/javascript"></script>`
//         ],
//         quizCompletion: [
//             `<a href="https://ad.doubleclick.net/ddm/jump/N7140.3546877SPEAKABLE/B22226397.245241127;sz=1x1;ord=timestamp?">
//                 <img src="https://ad.doubleclick.net/ddm/ad/N7140.3546877SPEAKABLE/B22226397.245241127;sz=1x1;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?" border=0 width=1 height=1 alt="Advertisement">
//             </a>`,
//             `<script src="https://cdn.doubleverify.com/dvtp_src.js?ctx=11646196&cmp=22226397&sid=5332969&plc=245241127&adsrv=1&btreg=&btadsrv=&crt=&tagtype=&dvtagver=6.1.src" type="text/javascript"></script>`
//         ],
//         videoStart: [
//             `<a href="https://ad.doubleclick.net/ddm/jump/N7140.3546877SPEAKABLE/B22226397.245241130;sz=1x1;ord=timestamp?">
//                 <img src="https://ad.doubleclick.net/ddm/ad/N7140.3546877SPEAKABLE/B22226397.245241130;sz=1x1;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?" border=0 width=1 height=1 alt="Advertisement">
//             </a>`,
//             `<script src="https://cdn.doubleverify.com/dvtp_src.js?ctx=11646196&cmp=22226397&sid=5332969&plc=245241130&adsrv=1&btreg=&btadsrv=&crt=&tagtype=&dvtagver=6.1.src" type="text/javascript"></script>`
//         ],
//         clickThrough: [
//             `<a href="https://ad.doubleclick.net/ddm/jump/N7140.3546877SPEAKABLE/B22226397.245241133;sz=1x1;ord=timestamp?">
//                 <img src="https://ad.doubleclick.net/ddm/ad/N7140.3546877SPEAKABLE/B22226397.245241133;sz=1x1;ord=timestamp;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?" border=0 width=1 height=1 alt="Advertisement">
//             </a>`,
//             `<script src="https://cdn.doubleverify.com/dvtp_src.js?ctx=11646196&cmp=22226397&sid=5332969&plc=245241133&adsrv=1&btreg=&btadsrv=&crt=&tagtype=&dvtagver=6.1.src" type="text/javascript"></script>`
//         ],
//         mystery: [
//             `<script src="https://cdn.doubleverify.com/dvtp_src.js?ctx=11646196&cmp=22226397&sid=5332969&plc=245241121&adsrv=1&btreg=&btadsrv=&crt=&tagtype=&dvtagver=6.1.src" type="text/javascript"></script>`
//         ]
//     }
// }
